<template>
    <div class="form_row">
        <label class="label_title" :for="question.label">
            {{ question.label }}
        </label>

        <component
            :is="`${question.type}-question`"
            :question="question"
            :class="{ 'is-invalid': !!error }"
            :error="!!error"
            @input="$emit('input', $event)"
        />

        <div class="invalid-feedback">
            {{ error }}
        </div>
    </div>
</template>

<script>
import types from './types';

export default {
    components: {
        ...types
    },

    props: {
        question: {
            type: Object,
            required: true
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    computed: {
        serverError() {
            return this.serverErrors.find(
                item => item.param === this.question.label
            );
        },

        error() {
            const {
                $error,
                required,
                isFormatValid,
                email,
                correctQuantity
            } = this.validation;

            if (this.serverError) {
                return this.serverError.message;
            }

            if (!$error) {
                return '';
            }

            if (!required) {
                return 'אסור להשאיר ריק!';
            }

            if (!isFormatValid) {
                return 'סוג קובץ לא חוקי!';
            }

            if (!email) {
                return 'כתובת דוא"ל לא תקינה!';
            }

            if (!correctQuantity) {
                return `מוכרח להיות פה משהו`;
            }

            return 'Something is wrong... 🤔';
        }
    }
};
</script>
